var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUploadSlow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "#FFA755"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.3933 11.2337C16.2218 10.9249 15.7778 10.9249 15.6064 11.2337L10.5552 20.3316C10.3887 20.6315 10.6056 21 10.9487 21H21.0511C21.3941 21 21.611 20.6315 21.4445 20.3316L16.3933 11.2337ZM14.295 10.5056C15.0378 9.16765 16.9619 9.16765 17.7047 10.5056L22.7559 19.6034C23.4776 20.9032 22.5377 22.5 21.0511 22.5H10.9487C9.46204 22.5 8.52218 20.9032 9.24379 19.6034L14.295 10.5056ZM15.9999 13.5C16.4141 13.5 16.7499 13.8358 16.7499 14.25V16.75C16.7499 17.1642 16.4141 17.5 15.9999 17.5C15.5857 17.5 15.2499 17.1642 15.2499 16.75V14.25C15.2499 13.8358 15.5857 13.5 15.9999 13.5ZM15.9999 20C16.4141 20 16.7499 19.6642 16.7499 19.25C16.7499 18.8358 16.4141 18.5 15.9999 18.5C15.5857 18.5 15.2499 18.8358 15.2499 19.25C15.2499 19.6642 15.5857 20 15.9999 20Z",
  fill: "white"
})));
export { SvgUploadSlow as ReactComponent };